import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Title1 } from '../../components/Typography';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { getProductItemCount } from './utils/displayOptionsItems';
import Slider from 'react-slick';
import OrderHistoryModal from './components/OrderHistoryModal';
import OrderHistoryItem from './OrderHistoryItem';
const responsive = {
  desktop: {
    breakpoint: { max: 1700, min: 1024 },
    items: 3,
    // paritialVisibilityGutter: 60,
  },
  // tablet: {
  //   breakpoint: { max: 1024, min: 464 },
  //   items: 2,
  //   paritialVisibilityGutter: 50,
  // },
  // mobile: {
  //   breakpoint: { max: 464, min: 0 },
  //   items: 1,
  //   paritialVisibilityGutter: 30,
  // },
};
const Wrapper = styled.div``;
const TitleWrapper = styled.div`
  width: max-content;
  font-weight: 600;
  :after {
    content: '';
    display: block;
    width: calc(100% + 2px);
    padding-top: 2px;
    border-bottom: ${(props) => props.categoriesBarSelectedBorderColorWidth}
      solid ${(props) => props.theme.categoriesBarSelectedBorderColor};
  }
`;
const NoOrdersFound = styled(Title1)`
  text-align: center;
  color: ${(props) => props.theme.gray};
  margin-top: 64px;
`;
const NextArrow = styled.div`
  @media (max-width: 1100px) {
    right: 10px !important;
  }
  @media (max-width: 786px) {
    display: none !important;
  }
  @media (orientation: landscape) and (max-width: 1100px) {
    right: -20px !important;
  }
`;

const PrevArrow = styled.div`
  @media (max-width: 786px) {
    display: none !important;
  }
`;

function OrderHistoryNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <NextArrow
      className={className}
      style={{
        ...style,
        display: 'block',
        background: '#fff',
        borderRadius: '50%',
        border: 'none',
        height: '40px',
        width: '40px',
        boxShadow: ' 0 2px 5px 0 rgba(59, 76, 112, 0.24)',
        // right: '-10px',
        opacity: 1,
        fontSize: '16px',
        lineHeight: '40px',
        textAlign: 'center',
      }}
      onClick={onClick}
    />
  );
}

function OrderHistoryPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <PrevArrow
      className={className}
      style={{
        ...style,
        display: 'block',
        background: '#fff',
        borderRadius: '50%',
        border: 'none',
        height: '40px',
        width: '40px',
        boxShadow: ' 0 2px 5px 0 rgba(59, 76, 112, 0.24)',
        // left: '-20px',
        opacity: 1,
        lineHeight: '40px',
        textAlign: 'center',
        zIndex: '1',
      }}
      onClick={onClick}
    />
  );
}
const slideSettings = {
  dots: false,
  infinite: false,
  speed: 600,
  arrows: true,
  rows: 1,
  slidesToShow: 0.3,
  slidesToScroll: 1,
  initialSlide: 0,
  swipeToSlide: true,
  variableWidth: true,
  centerPadding: '60px',
  nextArrow: <OrderHistoryNextArrow />,
  prevArrow: <OrderHistoryPrevArrow />,
};
const OrderHistory = ({
  orderHistory,
  addPastOrderToCart,
  isCategory,
  editPreviousProductConfiguration,
  orderHistoryModalIsVisible,
  products,
  handleOpenHistoryModal,
  selectedOrderHistory,
  selectedProducts,
  selectedLocation,
  combos,
  locations,
}) => {
  return (
    <Wrapper isCategory={isCategory}>
      <TitleWrapper>
        <Title1 style={{ fontWeight: '600' }}>Order Again</Title1>
      </TitleWrapper>
      <div style={{ width: '67vw' }}>
        <Slider {...slideSettings}>
          {!orderHistory.length ? (
            <NoOrdersFound>No Orders Found</NoOrdersFound>
          ) : (
            orderHistory.map((order, index) => (
              <Fragment key={`order-history-${index + 1}`}>
                <OrderHistoryItem
                  order={order}
                  addPastOrderToCart={addPastOrderToCart}
                  getProductItemCount={getProductItemCount}
                  products={products}
                  editPreviousProductConfiguration={
                    editPreviousProductConfiguration
                  }
                  handleOpenHistoryModal={handleOpenHistoryModal}
                  selectedLocation={selectedLocation}
                  combos={combos}
                  locations={locations}
                />
              </Fragment>
            ))
          )}
        </Slider>
      </div>
      <OrderHistoryModal
        open={orderHistoryModalIsVisible && selectedOrderHistory}
        addPastOrderToCart={addPastOrderToCart}
        editPreviousProductConfiguration={editPreviousProductConfiguration}
        products={products}
        selectedOrderHistory={selectedOrderHistory}
        selectedProducts={selectedProducts}
        selectedLocation={selectedLocation}
        combos={combos}
      />
    </Wrapper>
  );
};

export default OrderHistory;
